import produce from 'immer';
import { AnyAction } from 'redux';
import {
  GET_SCHEDULE_RESERVATION_COMPLETE_DISPATCH,
  GET_SCHEDULE_RESERVATION_DISPATCH,
  SCHEDULE_DISPATCH,
} from '../../actions';

export type stateScheduleReservation = {
  scheduleDispatch: {
    clubId: number;
    imageDate: string;
    programId: string;
    showPopFlag: boolean;
  };
  scheduleReservation: {
    contentsId: number;
    clubId: number;
    clubName: string;
    infoDate: string;
    contentStartTime: string;
    contentEndTime: string;
    week: string;
    selectEqId: number;
    selectCompanionNum: number;
  };
  scheduleCompleteReservation: {
    registerFlg: number; // 1:予約 2:キャンセル待ち
    clubName: string;
    reservationDateTime: string;
    cancelTime: string;
    companionNum: number;
    annexFlag: number;
    contentsName: string;
    spaceName: string;
  };
};

const initialState: stateScheduleReservation = {
  scheduleDispatch: {
    clubId: 0,
    imageDate: '',
    programId: '',
    showPopFlag: false,
  },
  scheduleReservation: {
    contentsId: 0,
    clubId: 0,
    clubName: '',
    infoDate: '',
    contentStartTime: '',
    contentEndTime: '',
    week: '',
    selectEqId: 0,
    selectCompanionNum: 0,
  },
  scheduleCompleteReservation: {
    registerFlg: 1,
    clubName: '',
    reservationDateTime: '',
    cancelTime: '',
    companionNum: 0,
    annexFlag: 0,
    contentsName: '',
    spaceName: '',
  },
};

const ScheduleReservationStateReducer = (prevState = initialState, action: AnyAction): stateScheduleReservation => {
  return produce(prevState, (draft) => {
    const state = draft;
    switch (action.type) {
      case SCHEDULE_DISPATCH:
        if (action.clubId !== undefined) {
          state.scheduleDispatch.clubId = action.clubId;
        }
        if (action.programId !== undefined) {
          state.scheduleDispatch.programId = action.programId;
        }
        if (action.imageDate !== undefined) {
          state.scheduleDispatch.imageDate = action.imageDate;
        }
        if (action.showPopFlag !== undefined) {
          state.scheduleDispatch.showPopFlag = action.showPopFlag;
        }
        break;
      case GET_SCHEDULE_RESERVATION_DISPATCH:
        state.scheduleReservation.contentsId = action.contentsId;
        state.scheduleReservation.clubId = action.clubId;
        state.scheduleReservation.clubName = action.clubName;
        state.scheduleReservation.infoDate = action.infoDate;
        state.scheduleReservation.contentStartTime = action.contentStartTime;
        state.scheduleReservation.contentEndTime = action.contentEndTime;
        state.scheduleReservation.week = action.week;
        state.scheduleReservation.selectEqId = action.selectEqId;
        state.scheduleReservation.selectCompanionNum = action.selectCompanionNum;
        break;
      case GET_SCHEDULE_RESERVATION_COMPLETE_DISPATCH:
        state.scheduleCompleteReservation.registerFlg = action.registerFlg;
        state.scheduleCompleteReservation.clubName = action.clubName;
        state.scheduleCompleteReservation.reservationDateTime = action.reservationDateTime;
        state.scheduleCompleteReservation.cancelTime = action.cancelTime;
        state.scheduleCompleteReservation.companionNum = action.companionNum;
        state.scheduleCompleteReservation.annexFlag = action.annexFlag;
        state.scheduleCompleteReservation.contentsName = action.contentsName;
        state.scheduleCompleteReservation.spaceName = action.spaceName;
        break;
      default:
        break;
    }
  });
};

export default ScheduleReservationStateReducer;
